export enum Language {
    nb = "nb",
    nn = "nn",
    en = "en"
}
